/* jslint esversion: 6 */

import React from "react"
import PropTypes from "prop-types"

const Header = ({ style, value, className }) => {
  if (value.match(/<html.+?>.*<\/html>/g)) {
    // TODO: Find a better way to set the label
    return (
      <th
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: value }}
        className={className}
        style={style}
        label="Header"
      />
    )
  }
  return (
    <th className={className} style={style}>
      {value}
    </th>
  )
}

Header.propTypes = {
  style: PropTypes.object,
  value: PropTypes.string.isRequired,
  className: PropTypes.string
}
Header.defaultProps = {
  style: undefined,
  className: ""
}

export default Header
